import { Paper, Stack, Text, Button, ThemeIcon } from '@mantine/core';
import { IconNotebook } from '@tabler/icons-react';

interface EmptyJournalStateProps {
  onAddClick: () => void;
}

export function EmptyJournalState({ onAddClick }: EmptyJournalStateProps) {
  return (
    <Paper p="xl" withBorder style={{ textAlign: 'center' }}>
      <Stack align="center" gap="md">
        <ThemeIcon size={64} radius="xl" variant="light">
          <IconNotebook size={32} />
        </ThemeIcon>

        <Text fw={500} size="lg">
          No journal entries yet
        </Text>

        <Text c="dimmed" size="sm" maw={300}>
          Record changes and reflections about your tank.
        </Text>

        <Button size="md" onClick={onAddClick}>
          Add First Entry
        </Button>
      </Stack>
    </Paper>
  );
}
